import axios from 'axios';
import { config } from '../config';

const API_URL = config.BACKEND_URL;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Get all countries
export const getAllCountries = async (activeOnly = false) => {
  try {
    const response = await api.get(`/api/countries`, {
      params: { activeOnly }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching countries:', error);
    throw error;
  }
};

// Get single country by ID
export const getCountryById = async (id) => {
  try {
    const response = await api.get(`/api/countries/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching country:', error);
    throw error;
  }
};

// Create new country (Editor and Admin only)
export const createCountry = async (countryData) => {
  try {
    const response = await api.post('/api/countries', countryData);
    return response.data;
  } catch (error) {
    console.error('Error creating country:', error);
    throw error;
  }
};

// Update country (Editor and Admin only)
export const updateCountry = async (id, countryData) => {
  try {
    const response = await api.put(`/api/countries/${id}`, countryData);
    return response.data;
  } catch (error) {
    console.error('Error updating country:', error);
    throw error;
  }
};

// Delete country (Editor and Admin only)
export const deleteCountry = async (id) => {
  try {
    const response = await api.delete(`/api/countries/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting country:', error);
    throw error;
  }
};

// Toggle active status (Editor and Admin only)
export const toggleActiveStatus = async (id) => {
  try {
    const response = await api.put(`/api/countries/${id}/toggle-active`);
    return response.data;
  } catch (error) {
    console.error('Error toggling country status:', error);
    throw error;
  }
};

export default {
  getAllCountries,
  getCountryById,
  createCountry,
  updateCountry,
  deleteCountry,
  toggleActiveStatus
};
